export default __webpack_public_path__ + "static/media/Double.30daf210.svg";